/* Karban PDP engine — shared by every product page. Each page defines window.PDP
   (name, finishes, gal cutouts, pimgs, specs, reviews, faqs) in an inline script
   BEFORE this file loads. Gallery = swipe carousel + left thumb rail (Lumone-B zoom
   pattern), zoom/pan lightbox, finish switch, check-delivery (30-min timer),
   FAQ-style specs accordion, review grid, feature swipe strip. */
var PDP = window.PDP || {};

var finish = PDP.defaultFinish || (PDP.finishes ? Object.keys(PDP.finishes)[0] : 'default');
var galIdx = 0;

function hasCutout(){ return !!(PDP.gal && PDP.gal[finish]); }
function galItems() {
  var photos = (PDP.pimgs[finish] || []).slice();

  if (hasCutout() && photos.length) {
    var hero = PDP.gal[finish].split('?')[0].split('/').pop();
    var first = photos[0].split('?')[0].split('/').pop();

    if (hero === first) {
      photos.shift();
    }
  }

  photos = photos.map(function(s) {
    return { src: s, type: PDP.rawMedia ? 'prod' : 'life' };
  });

  return hasCutout()
    ? [{ src: PDP.gal[finish], type: 'prod' }].concat(photos)
    : photos;
}

/* ---- carousel: scroll-snap slides + dots + thumbs, all kept in sync ---- */
function renderGallery(){
  var items=galItems();
  document.getElementById('pcar').innerHTML=items.map(function(it,i){
    return '<div class="pslide '+(it.type==='prod'?'prod':'')+'"><img src="'+it.src+'" alt="'+PDP.name+' — image '+(i+1)+'" onclick="openLB('+i+')"'+(i>0?' loading="lazy"':'')+'></div>'; }).join('');
  var pd=document.getElementById('pdots'); if(pd) pd.innerHTML=(items.length>1?items.map(function(it,i){
    return '<button class="pdot '+(i===galIdx?'on':'')+'" onclick="pickHero('+i+')" aria-label="Image '+(i+1)+'"></button>'; }).join(''):'');
  var gt=document.getElementById('galThumbs'); if(gt) gt.innerHTML=(items.length>1?items.map(function(it,i){
    return '<button class="gal-thumb '+(it.type==='prod'?'prod ':'')+(i===galIdx?'on':'')+'" onclick="pickHero('+i+')"><img src="'+it.src+'" alt=""></button>'; }).join(''):'');
}
function setDot(i){
  galIdx=i;
  document.querySelectorAll('.pdot').forEach(function(d,j){ d.classList.toggle('on', j===i); });
  document.querySelectorAll('.gal-thumb').forEach(function(t,j){ t.classList.toggle('on', j===i); });
}
function pickHero(i){ var c=document.getElementById('pcar'); c.scrollTo({left:i*c.clientWidth,behavior:'smooth'}); setDot(i); }
function carStep(d){ var c=document.getElementById('pcar'), n=galItems().length;
  pickHero(Math.max(0, Math.min(n-1, Math.round(c.scrollLeft/c.clientWidth)+d))); }
function setFinish(f){
  finish=f;
  var lbl=document.getElementById('finishLabel'); if(lbl && PDP.finishes) lbl.textContent=PDP.finishes[f];
  document.querySelectorAll('.finish .opt').forEach(function(o){ o.classList.toggle('on', o.dataset.finish===f); });
  renderGallery();
  var c=document.getElementById('pcar'); c.scrollTo({left:galIdx*c.clientWidth}); /* keep position, new finish */

  /* Keep every add-to-cart form (hero + sticky bar) pointed at the variant
     that matches the selected finish, and refresh the price shown next to it. */
  var v=PDP.variants && PDP.variants[f];
  if(v){
    document.querySelectorAll('.pdp-variant-id').forEach(function(inp){ inp.value=v.id; });
    var amt=document.getElementById('priceAmt'); if(amt) amt.textContent=v.price;
    var cmp=document.getElementById('priceCmp'); if(cmp){ cmp.textContent=v.cmp; cmp.style.display=v.showCmp?'':'none'; }
    var atc=document.getElementById('atcPrice'); if(atc) atc.textContent=v.price;
    var pb=document.getElementById('pbarPrice'); if(pb) pb.textContent=v.price;
    syncAtcAvailability(v);
  }
}
/* Reflect the selected finish's stock directly in the Add to Cart buttons
   (hero + sticky bar). PDP.prebookMode is the single switch: false disables
   the button and shows "Sold out"; true reveals a disabled "Out of stock"
   pill (hero only) next to a clickable "Prebook" CTA + 15-day delivery note
   (full payment still taken at checkout — requires "Continue selling when
   out of stock" ON in Shopify Admin, otherwise Shopify's own cart API
   rejects the add regardless of this label). */
function syncAtcAvailability(v){
  var outOfStock = !!(v && v.prebook);
  var prebookMode = !!(PDP.prebookMode);
  var twoButtons = outOfStock && prebookMode;
  var useAmazon = !!(PDP.amazonUrl);
  var showAmazon = twoButtons && useAmazon;
  document.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach(function(btn){
    var lbl = btn.querySelector('.atc-label');
    btn.style.display = showAmazon ? 'none' : '';
    btn.classList.toggle('is-soldout', outOfStock && !prebookMode);
    btn.classList.toggle('is-prebook', twoButtons && !useAmazon);
    btn.disabled = outOfStock && !prebookMode;
    if(lbl) lbl.textContent = !outOfStock ? 'Add to cart' : (prebookMode ? 'Prebook' : 'Sold out');
  });
  document.querySelectorAll('.js-amazon-cta').forEach(function(a){
    a.style.display = showAmazon ? '' : 'none';
  });
  var oosBtn = document.getElementById('outOfStockBtn');
  if(oosBtn) oosBtn.style.display = twoButtons ? '' : 'none';
  var subnote = document.getElementById('atcSubnote');
  if(subnote) subnote.style.display = (twoButtons && !useAmazon) ? '' : 'none';
}

/* ---- lightbox: browse the PHOTOS only — clicking a transparent cutout render
   (slide 0) opens the first real photo, never the cutout on the dark backdrop ---- */
var LB={list:[],i:0};
function lbShow(){
  var img=document.getElementById('zoomImg');
  img.classList.remove('zin'); img.style.transformOrigin='center'; img.src=LB.list[LB.i];
  var nav=LB.list.length>1?'':'none';
  document.getElementById('zPrev').style.display=nav; document.getElementById('zNext').style.display=nav;
  document.getElementById('zCount').style.display=nav;
  document.getElementById('zCount').textContent=(LB.i+1)+' / '+LB.list.length;
  document.getElementById('zoom').classList.add('open'); document.body.style.overflow='hidden';
}
function openLB(i){ LB.list=galItems().map(function(it){return it.src;}); LB.i=Math.max(0, Math.min(i, LB.list.length-1)); lbShow(); }
function zoomSrc(src){ LB.list=[src]; LB.i=0; lbShow(); }  /* single image (review photos) */
function lbStep(d){ LB.i=(LB.i+d+LB.list.length)%LB.list.length; lbShow(); }
function lbOrigin(e){ var img=document.getElementById('zoomImg');
  if(!img.classList.contains('zin')){ img.style.transformOrigin='center'; return; }
  var r=img.getBoundingClientRect();
  img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'; }
function toggleZoom(e){ e.stopPropagation(); var img=document.getElementById('zoomImg'); img.classList.toggle('zin'); lbOrigin(e); }
function closeZoom(){ document.getElementById('zoom').classList.remove('open'); document.body.style.overflow=''; }

/* ---- Check delivery — persistent 30-min free-install timer ---- */
var KARBAN_PV2_KEY='karban_pv2', INSTALL_DUR=30*60, _dvT, _dvD;
function pvStart(){ var d={}; try{ d=JSON.parse(localStorage.getItem(KARBAN_PV2_KEY)||'{}'); }catch(e){}
  if(!d.installTimerStart){ d.installTimerStart=Date.now(); try{ localStorage.setItem(KARBAN_PV2_KEY,JSON.stringify(d)); }catch(e){} } return d.installTimerStart; }
function pvRemaining(){ return Math.max(0, INSTALL_DUR - Math.floor((Date.now()-pvStart())/1000)); }
function pvSave(pin, installOk){ var d={}; try{ d=JSON.parse(localStorage.getItem(KARBAN_PV2_KEY)||'{}'); }catch(e){}
  d.pin=pin; d.installOk=(installOk===true); if(!d.installTimerStart) d.installTimerStart=Date.now(); try{ localStorage.setItem(KARBAN_PV2_KEY,JSON.stringify(d)); }catch(e){} }
function fmtDate(d){ return d.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'}); }
function dispatchLeft(){ var end=new Date(); end.setHours(23,59,0,0); var s=Math.max(0,(end-new Date())/1000); return {h:Math.floor(s/3600), m:Math.floor((s%3600)/60)}; }

/* Free-install eligibility: pincode -> India Post lookup -> match the
   configured serviceable-city list (same mechanic as the live theme's
   pincode widget). The install block renders ONLY for serviceable cities
   (Shubham, 19 Jul). API failure = no install promise, delivery info only. */
function installEligible(po){
  // Free installation temporarily disabled.
  // var list=(PDP.installCities||[]).map(function(s){return String(s).trim().toLowerCase();}).filter(Boolean);
  // if(!list.length || !po) return false;
  // var cands=[po.Name,po.District,po.State,po.Block].filter(Boolean).map(function(s){return String(s).toLowerCase();});
  // return list.some(function(item){ return cands.some(function(c){ return c===item || c.indexOf(item)>-1; }); });
  return false;
}
function showDeliv(pin, canInstall){
  var res=document.getElementById('dvRes'), inp=document.getElementById('dvInput');
  if(!res || !inp) return;   /* page without the delivery widget */
  inp.style.display='none';
  var arr=new Date(); arr.setDate(arr.getDate()+4); var cd=dispatchLeft();
  res.classList.add('show');
  res.innerHTML=
    '<div class="dv-confirm"><span class="dv-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span>'+
      '<span class="t">Delivering to <strong>'+pin+'</strong></span><button class="dv-change" onclick="dvReset()">Change</button></div>'+
    '<div class="dv-div"></div>'+
    '<div class="dv-tags"><span class="dv-tag">Free delivery</span><span class="dv-tag">In stock</span></div>'+
    '<div class="dv-arrives">Arrives by '+fmtDate(arr)+'</div>'+
    '<div class="dv-count"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Order within <strong id="dv-disp">'+cd.h+'h '+cd.m+'m</strong> for the fastest dispatch</div>'+
    (PDP.installUpsell===false || canInstall!==true ? '' :
    '<div class="dv-install" id="dvInstall">'+
      '<div class="dv-inst-top"><span class="dv-inst-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-2.4 2.6-2.6z"/></svg></span>'+
        '<span class="dv-inst-title">Free professional installation<span class="dv-old">₹999</span><span class="dv-free">Free</span></span></div>'+
      '<div class="dv-inst-desc">A Karban-certified technician mounts, pairs and tests your Karban — we call to book a slot.</div>'+
      '<div class="dv-inst-act">'+
        '<div class="dv-timer"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="12" cy="12" r="10"/><polyline points="12 7 12 12 15 14"/></svg><span class="dv-tlbl">Free install held for</span><span class="dv-tval" id="dv-tval">--:--</span></div>'+
        '<button class="dv-add" onclick="dvAdd(this)"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Add</button>'+
      '</div>'+
    '</div>');
  clearInterval(_dvD); _dvD=setInterval(function(){ var el=document.getElementById('dv-disp'); if(!el){clearInterval(_dvD);return;} var c=dispatchLeft(); el.textContent=c.h+'h '+c.m+'m'; },60000);
  clearInterval(_dvT);
  function tick(){ var t=document.getElementById('dv-tval'); if(!t){clearInterval(_dvT);return;} var r=pvRemaining();
    if(r<=0){ t.textContent='00:00'; var b=document.getElementById('dvInstall'); if(b)b.classList.add('expired'); var l=document.querySelector('.dv-tlbl'); if(l)l.textContent='Free install — call us to claim'; clearInterval(_dvT); return; }
    t.textContent=Math.floor(r/60)+':'+String(r%60).padStart(2,'0'); }
  tick(); _dvT=setInterval(tick,1000);
}
function checkDeliv(){
  var v=(document.getElementById('pin').value||'').trim();
  var res=document.getElementById('dvRes');
  if(!/^\d{6}$/.test(v)){ res.classList.add('show'); res.innerHTML='<div style="font-size:13px;color:var(--ink)">Please enter a valid 6-digit pincode.</div>'; return; }
  res.classList.add('show'); res.innerHTML='<div style="font-size:13px;color:var(--ink)">Checking…</div>';
  fetch('https://api.postalpincode.in/pincode/'+v)
    .then(function(r){ return r.json(); })
    .then(function(data){
      var po=(data && data[0] && data[0].PostOffice && data[0].PostOffice[0]) || null;
      var ok=installEligible(po);
      pvSave(v, ok);
      showDeliv(v, ok);
    })
    .catch(function(){ pvSave(v,false); showDeliv(v,false); });
}
function dvReset(){ document.getElementById('dvInput').style.display=''; var res=document.getElementById('dvRes'); res.classList.remove('show'); res.innerHTML='';
  clearInterval(_dvT); clearInterval(_dvD); var p=document.getElementById('pin'); if(p){ p.value=''; p.focus(); } }  /* timer start persists in localStorage */
/* Free-install "Add" button: adds the ₹0 installation variant PLUS the main
   product's currently selected variant (if not already in the cart), then
   refreshes/opens the cart drawer the same way kbv4WireATC does. */
function dvAdd(btn){
  if(btn._busy) return;
  btn._busy=true;
  var original=btn.innerHTML;
  btn.innerHTML='Adding…';

  var prodInput=document.querySelector('.buy-cta input[name="id"]') || document.querySelector('.pbar input[name="id"]');
  var prodVariant=prodInput ? parseInt(prodInput.value) : 0;
  var installVariant=parseInt(PDP.installVariantId) || 0;

  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    var items=(cart.items||[]);
    var installInCart=installVariant ? items.some(function(i){ return i.variant_id===installVariant; }) : false;
    var prodInCart=prodVariant ? items.some(function(i){ return i.variant_id===prodVariant; }) : false;

    var toAdd=[];
    if(prodVariant && !prodInCart) toAdd.push({ id: prodVariant, quantity: 1 });
    if(installVariant && !installInCart) toAdd.push({ id: installVariant, quantity: 1 });

    if(!toAdd.length){
      btn.classList.add('added'); btn.innerHTML='Added to cart';
      return Promise.reject('skip');
    }

    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ items: toAdd, sections: ['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(x){ return Promise.reject(x); });
      return r.json();
    }).then(function(data){
      var d=document.querySelector('cart-drawer');
      /* Dawn bug: renderContents() only clears .drawer__inner's is-empty, not the
         <cart-drawer> HOST's, and CSS hides header/inner while the host still has
         it — leaving a blank drawer on a visitor's first add. */
      if(d) d.classList.remove('is-empty');
      if(d && data.sections && typeof d.renderContents==='function'){
        d.renderContents(data);
      } else if(d && typeof d.open==='function'){
        d.open();
      } else if(d){
        d.classList.add('animate','active'); document.body.classList.add('overflow-hidden');
      }
      btn.classList.add('added');
      btn.innerHTML='Added to cart';
    });
  }).catch(function(err){
    if(err==='skip') return;
    console.error('[Karban] dvAdd failed:', err);
    btn.innerHTML=original;
  }).finally(function(){ btn._busy=false; });
}
function restoreDeliv(){ var d={}; try{ d=JSON.parse(localStorage.getItem(KARBAN_PV2_KEY)||'{}'); }catch(e){} if(d.pin){ var p=document.getElementById('pin'); if(p)p.value=d.pin; showDeliv(d.pin, d.installOk===true); } }

/* ---- Free HEPA filter promo: 15-min countdown, persisted per browser tab
   session (sessionStorage) so it doesn't reset to 15:00 on every reload —
   once it starts for a visitor, it keeps counting down consistently until
   it actually expires or the tab is closed. ---- */
var HEPA_PROMO_KEY='karban_hepa_promo_end';
var _hepaT=null;
function hepaToggle(headBtn){
  var el=document.getElementById('hepaPromo');
  if(!el) return;
  var open=el.classList.toggle('is-open');
  headBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
}
function hepaPromoInit(){
  var el=document.getElementById('hepaPromo');
  if(!el) return;
  var end=parseInt(sessionStorage.getItem(HEPA_PROMO_KEY),10);
  if(!end || isNaN(end)){
    end=Date.now()+15*60*1000;
    try{ sessionStorage.setItem(HEPA_PROMO_KEY, String(end)); }catch(e){}
  }
  function tick(){
    var remain=Math.max(0, end-Date.now());
    var timerEl=document.getElementById('hepaTimerVal');
    if(remain<=0){
      clearInterval(_hepaT);
      if(timerEl) timerEl.textContent='Expired';
      el.classList.add('expired');
      var btn=document.getElementById('hepaClaimBtn');
      if(btn && !btn.classList.contains('added')){ btn.disabled=true; btn.textContent='Offer expired'; }
      return;
    }
    var mins=Math.floor(remain/60000), secs=Math.floor((remain%60000)/1000);
    if(timerEl) timerEl.textContent=String(mins).padStart(2,'0')+':'+String(secs).padStart(2,'0');
  }
  tick();
  _hepaT=setInterval(tick,1000);

  /* Reflect already-claimed state on load (e.g. came back to the page). */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var hepaVariant=parseInt(PDP.freeHepaVariantId)||0;
    if(!hepaVariant) return;
    var inCart=(cart.items||[]).some(function(i){ return i.variant_id===hepaVariant; });
    if(inCart){
      clearInterval(_hepaT);
      var btn=document.getElementById('hepaClaimBtn');
      if(btn){ btn.classList.add('added'); btn.textContent='✓ Added to cart'; btn.disabled=true; }
      el.classList.add('is-open');
      var head=el.querySelector('.hepa-promo__head');
      if(head) head.setAttribute('aria-expanded','true');
    }
  }).catch(function(){});
}
document.addEventListener('DOMContentLoaded', hepaPromoInit);
document.addEventListener('DOMContentLoaded', function(){ hepaLockQtyStepper(); });

/* Free HEPA gift must stay at qty 1.
   Primary defence: disable the line item's own "+" stepper so it can't be
   clicked past 1 in the first place — instant, no round-trip, no visible
   flash. Re-applied on every cart-drawer render since the drawer's HTML
   (and any disabled state on it) gets fully replaced on each render,
   whether triggered by us or by Shopify's native quantity-change code.
   Safety net: also self-corrects via /cart/change.js if it's ever found
   above 1 anyway (e.g. a render this listener didn't run in time for),
   using the cart data already attached to the event — no extra fetch. */
function hepaLockQtyStepper(){
  var hepaVariant = parseInt((window.PDP || {}).freeHepaVariantId) || 0;
  if (!hepaVariant) return;
  var qtyInput = document.querySelector('input[data-quantity-variant-id="'+hepaVariant+'"]');
  if (!qtyInput) return;
  var wrapper = qtyInput.closest('quantity-input') || qtyInput.parentElement;
  var plusBtn = wrapper && wrapper.querySelector('button[name="plus"]');
  if (plusBtn) plusBtn.disabled = true;
}
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  var _hepaQtyFixing = false;
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    hepaLockQtyStepper();
    if (_hepaQtyFixing) return;
    var hepaVariant = parseInt((window.PDP || {}).freeHepaVariantId) || 0;
    if (!hepaVariant) return;
    var items = (data && data.cartData && data.cartData.items) || [];
    var item = items.filter(function (i) { return i.variant_id === hepaVariant; })[0];
    if (item && item.quantity > 1) {
      _hepaQtyFixing = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: hepaVariant, quantity: 1 })
      }).then(function () {
        return fetch('/?sections=cart-drawer');
      }).then(function (r) { return r.json(); }).then(function (secData) {
        var html = secData['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cur = document.querySelector('cart-drawer'), inner = doc.querySelector('cart-drawer');
        if (cur && inner) { cur.innerHTML = inner.innerHTML; cur.classList.remove('is-empty'); }
        hepaLockQtyStepper();
      }).catch(function () {}).finally(function () { _hepaQtyFixing = false; });
    }
  });
}

/* Bridge for snippets/lead-form.liquid: called after a successful
   phone-number submit with leadAction === 'hepa-claim'. */
window.hepaClaimAfterLead = function(){
  var btn=document.getElementById('hepaClaimBtn');
  if(btn) hepaClaim(btn);
};

function hepaClaim(btn){
  if(btn._busy || btn.classList.contains('added')) return;
  btn._busy=true;
  var original=btn.textContent;
  btn.textContent='Adding…';

  var prodInput=document.querySelector('.buy-cta input[name="id"]') || document.querySelector('.pbar input[name="id"]');
  var prodVariant=prodInput ? parseInt(prodInput.value) : 0;
  var hepaVariant=parseInt(PDP.freeHepaVariantId) || 0;

  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    var items=(cart.items||[]);
    var hepaItem=hepaVariant ? items.filter(function(i){ return i.variant_id===hepaVariant; })[0] : null;
    var prodInCart=prodVariant ? items.some(function(i){ return i.variant_id===prodVariant; }) : false;
    /* Free gift — cap at qty 1 no matter what. If it's not in the cart yet,
       add it at qty 1. If something else (a cart-drawer stepper, etc.)
       already pushed it past 1, correct it back down instead of leaving it. */
    var hepaNeedsCorrection=hepaItem && hepaItem.quantity>1;

    var toAdd=[];
    if(prodVariant && !prodInCart) toAdd.push({ id: prodVariant, quantity: 1 });
    if(hepaVariant && !hepaItem) toAdd.push({ id: hepaVariant, quantity: 1 });

    if(!toAdd.length && !hepaNeedsCorrection){
      clearInterval(_hepaT);
      btn.classList.add('added'); btn.textContent='✓ Added to cart'; btn.disabled=true;
      return Promise.reject('skip');
    }

    var addStep = toAdd.length
      ? fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({ items: toAdd })
        }).then(function(r){
          if(!r.ok) return r.json().then(function(x){ return Promise.reject(x); });
        })
      : Promise.resolve();

    return addStep.then(function(){
      if(!hepaNeedsCorrection) return;
      return fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ id: hepaVariant, quantity: 1 })
      }).then(function(r){
        if(!r.ok) return r.json().then(function(x){ return Promise.reject(x); });
      });
    }).then(function(){
      return fetch('/?sections=cart-drawer');
    }).then(function(r){ return r.json(); }).then(function(data){
      var html=data['cart-drawer']; if(!html) return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var cur=document.querySelector('cart-drawer'), inner=doc.querySelector('cart-drawer');
      if(cur && inner){ cur.innerHTML=inner.innerHTML; cur.classList.remove('is-empty'); }
      hepaLockQtyStepper();
    }).then(function(){
      var d=document.querySelector('cart-drawer');
      if(d && typeof d.open==='function'){ d.open(); }
      else if(d){ d.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
      clearInterval(_hepaT);
      btn.classList.add('added');
      btn.textContent='✓ Added to cart';
      btn.disabled=true;
    });
  }).catch(function(err){
    if(err==='skip') return;
    console.error('[Karban] hepaClaim failed:', err);
    btn.textContent=original;
  }).finally(function(){ btn._busy=false; });
}

/* ---- Reviews (photo optional; photos zoom on click) ---- */
function ppReviewEscAttr(s) {
  return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function renderPPReviews() {
  var g = document.getElementById('pp-reviews');
  if (!g) return;
  var REV_LIMIT = 160;

  g.innerHTML = (PDP.reviews || []).map(function (r) {
    var ini = (r.name || '').replace('Dr. ', '').charAt(0).toUpperCase();

    // Build stars from rating
    var stars = '';
    for (var i = 0; i < (r.rating || 5); i++) {
      stars += '★';
    }

    // Truncate long reviews with a "Read more" toggle (shared window.toggleReviewText,
    // defined in kbv4-site.js.liquid — quote-agnostic, so it's safe to reuse here even
    // though these cards render without quote marks, unlike the home page's).
    var fullText = r.text || '';
    var isLong = fullText.length > REV_LIMIT;
    var shortText = isLong ? fullText.slice(0, REV_LIMIT).replace(/\s+\S*$/, '') + '…' : fullText;

    return `
      <div class="rcard">
        ${
  r.video
    ? `
      <div class="rvideo">
  <video
  poster="${r.img}"
  controls
  playsinline
  preload="metadata">
  <source src="${r.video}" type="video/mp4">
</video>
      </div>
      `
    : r.img
      ? `
        <div class="rimg" onclick="zoomSrc('${r.img}')">
          <img src="${r.img}" alt="Customer photo — ${PDP.name} installed" loading="lazy">
          <span class="zicon">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="7"></circle>
              <path d="m21 21-4.3-4.3M11 8v6M8 11h6"></path>
            </svg>
          </span>
        </div>`
      : `<span class="stars" style="font-size:14px">${stars}</span>`
}

        <div class="rt" data-full="${ppReviewEscAttr(fullText)}" data-short="${ppReviewEscAttr(shortText)}">${shortText}${isLong ? ' <button type="button" class="rt-more" onclick="toggleReviewText(this)">Read more</button>' : ''}</div>

        <div class="rf">
          <span class="ravatar">${ini}</span>

          <div>
            <div class="rn">${r.name || ''}</div>
            <div class="rm">
              ${stars} · ${r.location || PDP.name}
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

/* ---- Hero mini-reviews: auto-rotating pill next to the stars.
   Reuses PDP.reviews (same data as "The honest verdict"). Pure text, no click/
   modal (Shubham 2026-07-22: removed the click-to-open-photo interaction).
   Falls back to the static quote line when a product has no reviews. ---- */
var HQ = { items: [], i: 0, timer: null };

function hqClean(t){ return (t || '').replace(/^[\s“”"']+|[\s“”"']+$/g, '').trim(); }

function initHeroQuotes(){
  var el = document.getElementById('spQuoteTicker');
  if (!el) return;
  HQ.items = (PDP.reviews || []).filter(function(r){ return r && hqClean(r.text); });
  if (!HQ.items.length) return;                 /* keep the static fallback line */

  el.innerHTML = '<span class="sp-quote-rot in" id="spQuoteRot"></span>';
  hqShow(0, true);
  hqPlay();
}

function hqShow(i, instant){
  HQ.i = (i + HQ.items.length) % HQ.items.length;
  var r = HQ.items[HQ.i];
  var slot = document.getElementById('spQuoteRot');
  if (!slot) return;
  var label = '“' + hqClean(r.text) + '”' + (r.name ? ' — ' + r.name : '');
  if (instant) { slot.textContent = label; slot.classList.add('in'); return; }
  slot.classList.remove('in');                  /* fade out */
  setTimeout(function(){ slot.textContent = label; slot.classList.add('in'); }, 260);
}

function hqPlay(){ hqStop(); if (HQ.items.length > 1) HQ.timer = setInterval(function(){ hqShow(HQ.i + 1); }, 4200); }
function hqStop(){ if (HQ.timer) { clearInterval(HQ.timer); HQ.timer = null; } }

/* ---- full-review modal (built once, reused on both PDPs) ---- */
function buildReviewModal(){
  if (document.getElementById('revModal')) return;
  var m = document.createElement('div');
  m.className = 'rev-modal';
  m.id = 'revModal';
  m.setAttribute('role', 'dialog');
  m.setAttribute('aria-modal', 'true');
  m.setAttribute('aria-label', 'Customer review');
  m.innerHTML =
    '<div class="rev-modal-card">' +
      '<button class="rev-modal-x" type="button" aria-label="Close">×</button>' +
      '<div class="rev-modal-media"><img id="revModalImg" src="" alt=""></div>' +
      '<div class="rev-modal-body">' +
        '<div class="stars" id="revModalStars"></div>' +
        '<blockquote class="rev-modal-text" id="revModalText"></blockquote>' +
        '<div class="rev-modal-foot">' +
          '<span class="rev-modal-ini" id="revModalIni"></span>' +
          '<div><div class="rn" id="revModalName"></div><div class="rm" id="revModalMeta"></div></div>' +
        '</div>' +
        '<div class="rev-modal-nav" id="revModalNav">' +
          '<button type="button" class="rev-modal-prev" aria-label="Previous review">‹</button>' +
          '<span class="rev-modal-count" id="revModalCount"></span>' +
          '<button type="button" class="rev-modal-next" aria-label="Next review">›</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if (e.target === m) closeReviewModal(); });
  m.querySelector('.rev-modal-x').addEventListener('click', closeReviewModal);
  m.querySelector('.rev-modal-prev').addEventListener('click', function(){ openReviewModal(HQ.i - 1); });
  m.querySelector('.rev-modal-next').addEventListener('click', function(){ openReviewModal(HQ.i + 1); });
  document.addEventListener('keydown', function(e){
    if (!m.classList.contains('open')) return;
    if (e.key === 'Escape') closeReviewModal();
    if (e.key === 'ArrowRight') openReviewModal(HQ.i + 1);
    if (e.key === 'ArrowLeft') openReviewModal(HQ.i - 1);
  });
}

/* first product image available on this PDP — used when a review has no photo */
function pdpFallbackImg(){
  if (PDP.arThumb) return PDP.arThumb;
  if (PDP.gal) { if (PDP.gal.black) return PDP.gal.black; if (PDP.gal.white) return PDP.gal.white; }
  if (PDP.pimgs) { for (var k in PDP.pimgs) { if (PDP.pimgs[k] && PDP.pimgs[k].length) return PDP.pimgs[k][0]; } }
  return '';
}

function openReviewModal(i){
  var list = HQ.items.length ? HQ.items : (PDP.reviews || []);
  if (!list.length) return;
  buildReviewModal();
  HQ.i = (i + list.length) % list.length;
  var r = list[HQ.i];
  var stars = ''; for (var s = 0; s < (r.rating || 5); s++) stars += '★';
  var img = r.img || pdpFallbackImg();
  var media = document.querySelector('#revModal .rev-modal-media');
  var imgEl = document.getElementById('revModalImg');
  if (img) { imgEl.src = img; imgEl.alt = 'Customer photo — ' + (PDP.name || ''); media.style.display = ''; }
  else { media.style.display = 'none'; }
  document.getElementById('revModalStars').textContent = stars;
  document.getElementById('revModalText').textContent = '“' + hqClean(r.text) + '”';
  document.getElementById('revModalIni').textContent = (r.name || '').replace('Dr. ', '').charAt(0).toUpperCase() || '★';
  document.getElementById('revModalName').textContent = r.name || '';
  document.getElementById('revModalMeta').textContent = r.location || PDP.name || '';
  var nav = document.getElementById('revModalNav');
  nav.style.display = list.length > 1 ? '' : 'none';
  document.getElementById('revModalCount').textContent = (HQ.i + 1) + ' / ' + list.length;
  document.getElementById('revModal').classList.add('open');
  document.body.style.overflow = 'hidden';
  hqStop();
}

function closeReviewModal(){
  var m = document.getElementById('revModal');
  if (!m) return;
  m.classList.remove('open');
  document.body.style.overflow = '';
  hqPlay();
}
window.openReviewModal = openReviewModal;
window.closeReviewModal = closeReviewModal;

/* ---- FAQ ---- */
function faqTog(i){ var it=document.querySelectorAll('#faqList .faq-item')[i]; if(!it) return; var a=it.querySelector('.faq-a'); var open=it.classList.toggle('open'); a.style.maxHeight = open ? (a.scrollHeight+40)+'px' : '0px'; }

/* ---- specifications: FAQ-style accordion, first group open ---- */
function spTog(i){
  var it=document.querySelectorAll('#specAcc .faq-item')[i]; if(!it) return;
  var a=it.querySelector('.faq-a'); var open=it.classList.toggle('open');
  a.style.maxHeight = open ? (a.scrollHeight+40)+'px' : '0px';
}
function renderSpecs(){
  var el=document.getElementById('specAcc'); if(!el) return;
  el.innerHTML=(PDP.specs||[]).map(function(g,i){
    return '<div class="faq-item'+(i===0?' open':'')+'"><button class="faq-q" onclick="spTog('+i+')">'+g.c+
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'+
      '<div class="faq-a"><div class="spac-rows">'+
      g.rows.map(function(r){ return '<div class="sprow"><span class="k">'+r[0]+'</span><span class="v">'+r[1]+'</span></div>'; }).join('')+
      '</div></div></div>'; }).join('');
  var first=el.querySelector('.faq-item.open .faq-a');
  if(first) first.style.maxHeight=(first.scrollHeight+40)+'px';   /* first group always starts open */
}

/* ---- feature swipe strip (image left, text right) ---- */
function fsEl(){ return document.getElementById('fswipe'); }
function fsIdx(){ var c=fsEl(); if(!c||!c.children.length) return 0;
  return Math.max(0, Math.min(c.children.length-1, Math.round(c.scrollLeft/(c.children[0].offsetWidth+20)))); }
function fsDot(i){ document.querySelectorAll('#fsDots .pdot').forEach(function(d,j){ d.classList.toggle('on', j===i); }); }
function fsGo(i){ var c=fsEl(); var s=c.children[i]; if(!s) return;
  c.scrollTo({left:s.offsetLeft - c.offsetLeft, behavior:'smooth'}); fsDot(i); }
function fsStep(d){ var c=fsEl(); fsGo(Math.max(0, Math.min(c.children.length-1, fsIdx()+d))); }
function fsInit(){
  var c=fsEl(); if(!c) return;
  var dots=document.getElementById('fsDots');
  dots.innerHTML=Array.prototype.map.call(c.children, function(_,i){
    return '<button class="pdot '+(i===0?'on':'')+'" onclick="fsGo('+i+')" aria-label="Card '+(i+1)+'"></button>'; }).join('');
  var _ft; c.addEventListener('scroll', function(){ clearTimeout(_ft); _ft=setTimeout(function(){ fsDot(fsIdx()); },80); });
}

/* ---- experts swipe strip (Yogita leads, swipe to the next expert) ---- */
function esEl(){ return document.getElementById('expSwipe'); }
function esIdx(){ var c=esEl(); if(!c||!c.children.length) return 0;
  return Math.max(0, Math.min(c.children.length-1, Math.round(c.scrollLeft/(c.children[0].offsetWidth+20)))); }
function esDot(i){ document.querySelectorAll('#expDots .pdot').forEach(function(d,j){ d.classList.toggle('on', j===i); }); }
function esGo(i){ var c=esEl(); var s=c.children[i]; if(!s) return;
  c.scrollTo({left:s.offsetLeft - c.offsetLeft, behavior:'smooth'}); esDot(i); }
function esStep(d){ var c=esEl(); if(!c) return; esGo(Math.max(0, Math.min(c.children.length-1, esIdx()+d))); }
function esInit(){
  var c=esEl(); if(!c) return;
  var dots=document.getElementById('expDots');
  if(dots) dots.innerHTML=Array.prototype.map.call(c.children, function(_,i){
    return '<button class="pdot '+(i===0?'on':'')+'" onclick="esGo('+i+')" aria-label="Expert '+(i+1)+'"></button>'; }).join('');
  var _et; c.addEventListener('scroll', function(){ clearTimeout(_et); _et=setTimeout(function(){ esDot(esIdx()); },80); });
}

/* ---- Add to cart -> live cart drawer (Dawn contract) ----
   Both product forms (hero + sticky bar) post via AJAX, then the layout's
   cartRecoRefreshDrawer() re-renders the drawer section and we open it.
   If anything is missing (drawer disabled, JS error), the form falls back
   to its normal POST -> /cart page. Never breaks checkout. */
function kbv4WireATC(){
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
    if(f._kbv4) return; f._kbv4=true;
    f.addEventListener('submit', function(e){
      var drawer=document.querySelector('cart-drawer');
      if(!drawer || !window.fetch) return;           /* fallback: normal submit */
      e.preventDefault();
      var btn=f.querySelector('[type="submit"]');
      /* Swap only the .atc-label text (if present) instead of the whole
         button's textContent — the prebook markup nests .atc-top/.atc-subnote
         inside the button, and overwriting textContent/innerHTML wholesale
         permanently flattens that structure once restored afterward. */
      var lbl=btn?btn.querySelector('.atc-label'):null;
      var savedHTML=btn?btn.innerHTML:'';
      var savedLabel=lbl?lbl.textContent:null;
      if(btn){ btn.disabled=true; if(lbl){ lbl.textContent='Adding…'; } else { btn.textContent='Adding…'; } }
      var fd=new FormData(f);
      var items=[{ id: fd.get('id'), quantity: parseInt(fd.get('quantity')||'1',10) }];
      /* Tag the line item as a preorder so cart/checkout/the order-confirmation
         email all show it — visible property, not underscore-hidden, since the
         point is to set delivery-time expectations as early as possible. The
         order-confirmation notification template checks this same property
         name/value to swap in preorder delivery copy. */
      if(btn && btn.classList.contains('is-prebook')){
        items[0].properties = { 'Delivery': 'Ships after 15 days (Preorder)' };
      }
      /* Single round trip: ask /cart/add.js to also render the drawer + icon-bubble
         sections in the same response (Dawn's own bulk-add contract), then hand
         that straight to <cart-drawer>'s own renderContents() — same method Dawn's
         stock product-form.js uses, and already proven on the lumone PDP. Was 3
         sequential fetches (add -> /cart.js for count -> ?sections=cart-drawer);
         now 1. */
      fetch('/cart/add.js',{
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ items: items, sections: ['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname })
      })
        .then(function(r){ if(!r.ok) return r.json().then(function(x){return Promise.reject(x);}); return r.json(); })
        .then(function(data){
          /* Dawn bug: renderContents() only clears .drawer__inner's is-empty, not the
             <cart-drawer> HOST's — and CSS hides .drawer__header/.drawer__inner while
             the host still has it, leaving a blank drawer on a visitor's first add. */
          drawer.classList.remove('is-empty');
          if(data.sections && typeof drawer.renderContents==='function'){
            drawer.renderContents(data);
          } else if(typeof drawer.open==='function'){
            drawer.open();
          } else {
            drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden');
          }
        })
        .catch(function(err){ console.error('ATC failed:',err); alert((err&&err.description)||'Could not add to cart. Please try again.'); })
        .finally(function(){ if(btn){ btn.disabled=false; if(lbl && savedLabel!==null){ lbl.textContent=savedLabel; } else { btn.innerHTML=savedHTML; } } });
    });
  });
}

/* ---- 360° spin viewer — lazy: model-viewer lib + GLB load only on first open ---- */
function ensureMV(cb){
  if(window.customElements && customElements.get('model-viewer')){ cb(); return; }
  if(window.__mvQ){ window.__mvQ.push(cb); return; }
  window.__mvQ=[cb];
  var s=document.createElement('script'); s.type='module';
  s.src='https://unpkg.com/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
  s.onload=function(){ (window.__mvQ||[]).forEach(function(f){f();}); window.__mvQ=null; };
  document.head.appendChild(s);
}
function spinColor(){ return (finish==='white') ? 'white' : 'black'; }
function glbSrc(){ return PDP.glb ? (PDP.glb[spinColor()] || PDP.glb.black) : null; }
function openSpin(){
  var m=document.getElementById('spin3d'); if(!m) return;
  m.classList.add('open'); document.body.style.overflow='hidden';
  var mv=document.getElementById('spinMV');
  var src=glbSrc(); if(!src) return;
  ensureMV(function(){ if(mv.getAttribute('src')!==src) mv.setAttribute('src',src); });
}
/* ================= AR — "See it in your room" =================
   Flow (revamped 19 Jul — Shubham: users were dropped into the camera cold):
   1) Instruction sheet BEFORE launch: 3 steps + Start AR. Desktop gets a QR
      handoff to the phone. iPhone without a USDZ gets an honest 3D path.
   2) Start AR -> model-viewer activateAR(). ar-modes is "scene-viewer
      quick-look webxr" — NATIVE APPS FIRST as of 2026-07-23: Android's
      in-browser WebXR was going first specifically to host our own
      in-camera coaching + the vertical-move control, but that meant Android
      ran AR inside Chrome's own (less mature, more device-variable) WebXR
      implementation instead of Google's dedicated Scene Viewer app — which
      is exactly why AR felt smooth and easy to move on iPhone (always
      native Quick Look, since Safari has no WebXR AR) but janky on Android.
      Reordering so BOTH platforms default to their native AR app first
      trades away the custom coaching/vertical-move overlay on Android (it
      only ever ran inside WebXR) for AR that's as reliable as iPhone's.
      webxr is kept last as a rare fallback, not the primary path. The real
      fix for ceiling height is to bake the correct hang-height offset into
      each GLB/USDZ's own anchor point so native floor-anchored placement
      already looks right without any runtime adjustment — a 3D-asset task,
      not something this file can do alone.
   3) ios-src (USDZ) is wired through settings — iPhone AR switches on the
      day the brand team's USDZ files are uploaded. */
var arUA = navigator.userAgent || '';
var arIOS = /iPad|iPhone|iPod/.test(arUA) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
var arMobile = arIOS || /Android/i.test(arUA);
function usdzSrc(){ return (PDP.usdz && (PDP.usdz[spinColor()] || PDP.usdz.black)) || null; }

/* Mount-aware AR copy (fixed 2026-07-21 — Shubham: "point at the floor" is a
   vague/wrong instruction for a ceiling-only product like Pure Plus, which
   never touches the floor). model-viewer's AR only anchors off a FLOOR or
   WALL plane — there is no "ceiling" hit-test target — so a ceiling product
   still needs the floor point, but the copy must explain WHY, not just say
   "point at the floor" with no context. PDP.mount is 'ceiling' or 'floor',
   set per-product in the section schema (ar_mount). */
function arMountCopy(){
  if(PDP.mount === 'floor'){
    return {
      placeStepB: 'Point at the floor',
      placeStepRest: ' where you want it, and move your phone slowly in a small circle until it appears.',
      findingToast: 'Move your phone slowly to find your floor…'
    };
  }
  return {
    placeStepB: 'Point at the floor below where you’ll hang it',
    placeStepRest: ' — we anchor there, then show it suspended at true ceiling height above that spot.',
    findingToast: 'Move your phone slowly to find your floor — we’ll hang it above that spot…'
  };
}

function arSheetHTML(){
  var thumb = PDP.arThumb ? '<img class="ar-thumb" src="' + PDP.arThumb + '" alt="">' : '';
  if(!arMobile){
    var qr = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&margin=8&data=' +
             encodeURIComponent(location.href.split('#')[0]);
    return thumb +
      '<h3>See it in your room</h3>' +
      '<p class="ar-sub">AR works on your phone. Scan this code with your phone camera to open this page, then tap <b>See it in your room</b>.</p>' +
      '<img class="ar-qr" src="' + qr + '" alt="QR code — open this page on your phone" width="200" height="200">' +
      '<button type="button" class="btn btn-secondary btn-lg btn-block" onclick="arCloseSheet();openSpin()">Explore in 3D instead</button>';
  }
  if(arIOS && !usdzSrc()){
    return thumb +
      '<h3>See it in 3D</h3>' +
      '<p class="ar-sub">iPhone AR is coming soon for this product. Meanwhile, explore it in full 3D &mdash; drag to rotate, pinch to zoom.</p>' +
      '<button type="button" class="btn btn-primary btn-lg btn-block" onclick="arCloseSheet();openSpin()">Open 3D view</button>';
  }
  var copy = arMountCopy();
  return thumb +
    '<h3>See it in your room</h3>' +
    '<ol class="ar-steps">' +
      '<li><b>Allow camera access</b> when your phone asks.</li>' +
      '<li><b>' + copy.placeStepB + '</b>' + copy.placeStepRest + '</li>' +
      '<li><b>Drag to move</b> &middot; twist with two fingers to rotate &middot; use the <b>▲▼</b> control to raise or lower it. It shows at its true size.</li>' +
    '</ol>' +
    '<button type="button" id="arStart" class="btn btn-primary btn-lg btn-block" onclick="arStart()">Start AR</button>' +
    '<button type="button" class="ar-later" onclick="arCloseSheet()">Maybe later</button>';
}
function arOpenSheet(){
  var s = document.getElementById('arSheet');
  if(!s){
    s = document.createElement('div'); s.id = 'arSheet'; s.className = 'ar-sheet';
    s.innerHTML = '<div class="ar-card"><button class="ar-x" type="button" onclick="arCloseSheet()" aria-label="Close">&times;</button><div id="arCardBody"></div></div>';
    s.addEventListener('click', function(e){ if(e.target === s) arCloseSheet(); });
    document.body.appendChild(s);
  }
  document.getElementById('arCardBody').innerHTML = arSheetHTML();
  s.classList.add('open'); document.body.style.overflow = 'hidden';
}
function arCloseSheet(){
  var s = document.getElementById('arSheet');
  if(s){ s.classList.remove('open'); document.body.style.overflow = ''; }
}
function arToast(msg, hold){
  /* During a WebXR session only elements INSIDE <model-viewer> (the DOM-overlay
     root) are composited over the camera — so the toast lives there when it
     exists, and falls back to <body> for non-AR uses. */
  var host = document.getElementById('spinMV') || document.body;
  var t = document.getElementById('arToast');
  if(!t){ t = document.createElement('div'); t.id = 'arToast'; t.className = 'ar-toast'; }
  if(t.parentNode !== host) host.appendChild(t);
  t.textContent = msg; t.classList.add('on');
  clearTimeout(t.__h);
  if(hold !== true){ t.__h = setTimeout(function(){ t.classList.remove('on'); }, 4000); }
}
function arToastOff(){ var t = document.getElementById('arToast'); if(t){ t.classList.remove('on'); clearTimeout(t.__h); } }

/* ================= Vertical-move control (WebXR only) =================
   Shubham 21 Jul: "I should be able to move the product up and down."
   model-viewer has no public API to reposition a placed AR object directly
   (maintainers, github.com/google/model-viewer discussions/4302 — "well
   outside of our public API"). Their own recommended workaround: bake a
   vertical-move ANIMATION into the model, then scrub it with the public,
   documented `currentTime` property instead of touching position/matrices.
   Every production GLB now carries a 2-second 'verticalMove' clip: -0.4m
   at t=0, resting height at t=1, +0.4m at t=2 (see the AR pipeline notes —
   [[project_ar_overhaul_jul2026]]). This control drags that value.
   Mounted INSIDE <model-viewer> so it only ever composites over the camera
   during a WebXR session (Scene Viewer / Quick Look are separate native
   apps — our whole page, this control included, simply isn't on screen
   there; nothing to gate explicitly). model-viewer auto-intercepts
   `beforexrselect` on interactive elements inside it, so WebXR won't eat
   these taps as its own placement/rotate gestures. */
var VG_DURATION = 2;
function ensureVGumball(mv){
  var el = document.getElementById('vGumball');
  if(el) return el;
  el = document.createElement('div');
  el.id = 'vGumball';
  el.className = 'v-gumball';
  el.innerHTML =
    '<button type="button" class="vg-btn vg-up" aria-label="Raise">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>' +
    '</button>' +
    '<div class="vg-track"><div class="vg-thumb"></div></div>' +
    '<button type="button" class="vg-btn vg-down" aria-label="Lower">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12l7 7 7-7"/></svg>' +
    '</button>';
  mv.appendChild(el);
  wireVGumball(mv, el);
  return el;
}
function wireVGumball(mv, el){
  var track = el.querySelector('.vg-track'), thumb = el.querySelector('.vg-thumb');
  var dragging = false;
  function setT(t){
    t = Math.max(0, Math.min(VG_DURATION, t));
    if(typeof mv.pause === 'function') mv.pause();
    mv.currentTime = t;
    thumb.style.bottom = ((t / VG_DURATION) * 100) + '%';
  }
  function curT(){ return mv.currentTime || VG_DURATION / 2; }
  function yToT(clientY){
    var r = track.getBoundingClientRect();
    var pct = 1 - (clientY - r.top) / r.height;
    return pct * VG_DURATION;
  }
  setT(VG_DURATION / 2); /* start at resting height */
  thumb.addEventListener('pointerdown', function(e){ dragging = true; e.preventDefault(); });
  track.addEventListener('pointerdown', function(e){ if(e.target === thumb) return; setT(yToT(e.clientY)); dragging = true; e.preventDefault(); });
  window.addEventListener('pointermove', function(e){ if(dragging) setT(yToT(e.clientY)); });
  window.addEventListener('pointerup', function(){ dragging = false; });
  el.querySelector('.vg-up').addEventListener('click', function(){ setT(curT() + 0.15); });
  el.querySelector('.vg-down').addEventListener('click', function(){ setT(curT() - 0.15); });
}
function vgShow(mv){ ensureVGumball(mv).classList.add('show'); }
function vgHide(){ var el = document.getElementById('vGumball'); if(el) el.classList.remove('show'); }

/* ================= In-camera gesture legend (WebXR only) =================
   Shubham 21 Jul: "instructions also in the live camera view" — a fading
   4-second toast isn't enough; show a real, readable legend card the moment
   the product is placed, covering every gesture together (native + ours) so
   there's one coherent lesson instead of scattered hints. Same DOM-overlay
   mounting rule as the vertical control: lives inside <model-viewer>, so it
   only ever composites during an actual WebXR session. */
function ensureArLegend(mv){
  var el = document.getElementById('arLegend');
  if(el) return el;
  el = document.createElement('div');
  el.id = 'arLegend'; el.className = 'ar-legend';
  el.innerHTML =
    '<button type="button" class="al-x" aria-label="Close" onclick="document.getElementById(\'arLegend\').classList.remove(\'show\')">&times;</button>' +
    '<div class="al-row"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M2 12h20"/><path d="m9 5 3-3 3 3M9 19l3 3 3-3M5 9 2 12l3 3M19 9l3 3-3 3"/></svg><span><b>Drag</b> to move it</span></div>' +
    '<div class="al-row"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.6-6.3"/><path d="M21 3v5h-5"/></svg><span><b>Twist</b> with two fingers to rotate</span></div>' +
    '<div class="al-row"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7M5 19l7-7-7 7"/></svg><span>Use <b>▲▼</b> on the right to raise or lower it</span></div>';
  mv.appendChild(el);
  return el;
}
function alShow(mv){
  var el = ensureArLegend(mv);
  el.classList.add('show');
  clearTimeout(el.__h);
  el.__h = setTimeout(function(){ el.classList.remove('show'); }, 10000);
}
function alHide(){ var el = document.getElementById('arLegend'); if(el){ el.classList.remove('show'); clearTimeout(el.__h); } }

function seeInRoom(){ arOpenSheet(); }

function arStart(){
  var btn = document.getElementById('arStart');
  if(btn){ btn.disabled = true; btn.textContent = 'Preparing your room view…'; }
  openSpin();  /* loads model-viewer + the right-finish GLB */
  ensureMV(function(){
    var mv = document.getElementById('spinMV'); if(!mv) return;
    if(usdzSrc()) mv.setAttribute('ios-src', usdzSrc());
    if(!mv.__arWired){
      mv.__arWired = true;
      mv.__hasPlaced = false;
      /* WebXR sessions run inside the page, so we can coach live.
         Scene Viewer / Quick Look bring their own native coaching.
         BUG FIXED 2026-07-21: 'session-started' is NOT a one-time "AR just
         opened" event — WebXR/ARCore re-report it during ordinary tracking
         blips (the camera briefly re-finding the surface, which happens
         constantly and is normal) even AFTER the product is already placed.
         The old code unconditionally hid the height control + legend on
         EVERY 'session-started', so they'd flash in on placement and then
         vanish the next time tracking so much as blinked. Fix: track
         whether the object has been placed THIS session (`__hasPlaced`) and
         only hide on a genuine session end/failure — a mid-session
         'session-started' blip no longer nukes controls the user is
         actively using. */
      mv.addEventListener('ar-status', function(ev){
        var st = ev.detail.status;
        var copy = arMountCopy();
        if(st === 'session-started'){
          if(!mv.__hasPlaced){ arToast(copy.findingToast, true); vgHide(); alHide(); }
        }
        else if(st === 'object-placed'){
          mv.__hasPlaced = true;
          arToastOff(); vgShow(mv); alShow(mv);
        }
        else if(st === 'failed'){
          mv.__hasPlaced = false;
          arToastOff(); vgHide(); alHide(); closeSpin(); arOpenSheet();
          var b = document.getElementById('arCardBody');
          if(b) b.innerHTML = '<h3>AR couldn’t start</h3>' +
            '<p class="ar-sub">Your phone blocked AR or doesn’t support it. You can still explore the product in full 3D.</p>' +
            '<button type="button" class="btn btn-primary btn-lg btn-block" onclick="arCloseSheet();openSpin()">Open 3D view</button>';
        }
        else if(st === 'not-presenting'){ mv.__hasPlaced = false; arToastOff(); vgHide(); alHide(); }
      });
    }
    var go = function(){
      arCloseSheet();
      if(typeof mv.activateAR === 'function' && mv.canActivateAR){ mv.activateAR(); }
      else { openSpin(); arToast('AR isn’t available on this device — here’s the 3D view'); }
      if(btn){ btn.disabled = false; btn.textContent = 'Start AR'; }
    };
    if(mv.loaded){ go(); } else { mv.addEventListener('load', go, { once: true }); }
  });
}
function closeSpin(){ var m=document.getElementById('spin3d'); if(!m) return;
  m.classList.remove('open'); document.body.style.overflow=''; }
function initSpin(){
  if(!glbSrc()) return;   /* no hosted 3D model configured -> no 360 button, no dead UI */
  var wrap=document.querySelector('.car-wrap'); if(!wrap) return;
  var b=document.createElement('button');
  b.type='button'; b.className='spin3d-btn'; b.setAttribute('aria-label','View in 3D — 360°');
  b.onclick=openSpin;
  b.innerHTML='<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.6-6.3"/><path d="M21 3v5h-5"/><circle cx="12" cy="12" r="3.2"/></svg><span>360° view</span>';
  wrap.appendChild(b);
  var m=document.createElement('div');
  m.className='spin3d'; m.id='spin3d';
  m.addEventListener('click', function(e){ if(e.target===m) closeSpin(); });
  m.innerHTML=
    '<button class="spin3d-x" onclick="closeSpin()" aria-label="Close">&times;</button>'+
    /* NATIVE APPS FIRST (changed 2026-07-23 — see the AR flow comment above):
       scene-viewer/quick-look give both platforms the smooth, mature native
       AR experience by default. webxr stays last as a fallback only — our
       in-page coaching/vertical-move overlay still works when it's hit, it
       just won't be the common case anymore. */
    '<model-viewer id="spinMV" camera-controls auto-rotate rotation-per-second="18deg" interaction-prompt="none" '+
      'ar ar-modes="scene-viewer quick-look webxr" ar-scale="fixed" xr-environment '+
      'shadow-intensity="0.55" exposure="1.05" alt="'+(PDP.name||'Karban')+' — 3D view" '+
      'style="width:92vw;height:80vh;max-width:920px;background:#efeae0;border-radius:20px">'+
      '<div class="spin3d-load" slot="poster"><span class="spin"></span> Loading 3D model…</div>'+
    '</model-viewer>'+
    '<div class="spin3d-cap">Drag to rotate · scroll or pinch to zoom · switch finish on the page to recolour</div>';
  document.body.appendChild(m);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeSpin(); });
}

document.addEventListener('DOMContentLoaded', function(){
  /* Wire Add to Cart FIRST and unconditionally. If any of the render/init calls
     below throws (bad product data, malformed specs/reviews JSON, etc.) it must
     not be able to skip this — an unwired form falls back to a native POST,
     which Shopify redirects to /cart instead of opening the drawer. Each call
     below is isolated in its own try/catch for the same reason: one broken
     section shouldn't take the rest of the page's JS down with it. */
  kbv4WireATC();
  [renderGallery, renderPPReviews, initHeroQuotes, renderSpecs, fsInit, esInit, initSpin].forEach(function(fn){
    try{ fn(); }catch(err){ console.error('[Karban] PDP init failed:', fn.name, err); }
  });
  try{ syncAtcAvailability(PDP.variants && PDP.variants[finish]); }catch(err){ console.error('[Karban] PDP init failed:', 'syncAtcAvailability', err); }
  /* keep dots/thumbs in sync while swiping */
  var car=document.getElementById('pcar'), _st;
  if(car) car.addEventListener('scroll', function(){ clearTimeout(_st);
    _st=setTimeout(function(){ setDot(Math.round(car.scrollLeft/car.clientWidth)); },80); });
  /* lightbox: pan while zoomed, arrows browse, Esc closes */
  var zi=document.getElementById('zoomImg');
  if(zi) zi.addEventListener('mousemove', function(e){ if(zi.classList.contains('zin')) lbOrigin(e); });
var fl = document.getElementById('faqList');

if (fl) {
  fl.innerHTML = (PDP.faqs || []).map(function(f, i) {
    return `
      <div class="faq-item">
        <button class="faq-q" onclick="faqTog(${i})">
          ${f.q}
          <svg width="20" height="20" viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round">
            <path d="M12 5v14M5 12h14"/>
          </svg>
        </button>

        <div class="faq-a">
          <p>${f.a}</p>
        </div>
      </div>
    `;
  }).join('');
}
  restoreDeliv();
  if(location.hash==='#deliv'){ var p=document.getElementById('pin'); if(p) p.value='110001'; checkDeliv(); }
  document.addEventListener('keydown', function(e){
    var open=document.getElementById('zoom').classList.contains('open');
    if(e.key==='Escape') closeZoom();
    if(open && e.key==='ArrowRight') lbStep(1);
    if(open && e.key==='ArrowLeft') lbStep(-1);
  });
});